export default "/images/img_8.png?6ab51a47214dafb1810531f4b0955e3b";